interface IPublishOfferParams {
  publishTerms: any;
}

export const publishOfferNative = ({ publishTerms }: IPublishOfferParams) => ({
  action: 'publish-offer',
  payload: { publishTerms },
});

/**
 * Функция для генерации события в натив о том, что был клик на кнопку размещения.
 * @param isDisabled флаг внутри ФВУ, который ФВУ устанавливает, если клик на публикацию не будет обработан из-за наличия барьеров для публикации
 * @returns событие для нативного приложения
 */
export const generatePublishOfferClickAction = (isDisabled: boolean) => ({
  action: 'publish-click',
  payload: { isDisabled },
});
